import { Typography } from 'enable-ui';

import { InviteeListItem } from 'modules/calendar/components/InviteeListItem';
import { StatusSummary } from 'modules/calendar/components/StatusSummary';
import { Invitee } from 'modules/calendar/core/type';
import { InviteeGrid } from 'modules/calendar/styles/invitee-selector';
import { GroupHeader } from 'modules/calendar/styles/invitee-selector';

import { COLOR } from 'constants/color';

export const InviteeGroup = ({
  title,
  items,
  onRemoveInvitee,
}: {
  title: string;
  items: Invitee[];
  onRemoveInvitee?: (invitee: Invitee) => () => void;
}) => (
  <div className="full-width">
    <GroupHeader>
      <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']} weight={600}>
        {title}
      </Typography>
      <StatusSummary items={items} />
    </GroupHeader>
    <InviteeGrid>
      {items.map((invitee) => (
        <InviteeListItem
          key={invitee.id}
          invitee={invitee}
          isRemovable={false}
          onRemove={onRemoveInvitee ? onRemoveInvitee(invitee) : undefined}
        />
      ))}
    </InviteeGrid>
  </div>
);
